import { useRouterState } from '@tanstack/react-router'
import { CircleNotch } from '@phosphor-icons/react'

export function NavigationLoader() {
  const routerState = useRouterState()
  
  // Detecta se está navegando ou carregando uma rota
  // status pode ser 'idle' ou 'pending'
  const status = routerState.status
  const isNavigating = status === 'pending' || routerState.isLoading

  if (!isNavigating) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] pointer-events-none">
      {/* Barra de progresso no topo */}
      <div className="h-1 bg-indigo-500/20 w-full overflow-hidden relative">
        <div className="h-full w-1/3 bg-indigo-500 animate-[loading_1.5s_linear_infinite]" />
      </div>
      
      {/* Spinner no canto superior direito */}
      <div className="absolute top-4 right-4 pointer-events-auto">
        <div className="bg-background border border-border rounded-lg shadow-lg p-2">
          <CircleNotch className="h-5 w-5 animate-spin text-indigo-500" />
        </div>
      </div>
    </div>
  )
}

